<template>
  <div class="verify-slider-wrapper">
    <!-- 图片区域 -->
    <div class="verify-img-out" :style="{ height: parseInt(imgSize.height) + vSpace + 'px' }">
      <div class="verify-img-panel" :style="{ width: imgSize.width, height: imgSize.height }"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false"
      >
        <img
          :src="backImgBase ? 'data:image/png;base64,' + backImgBase : defaultImg"
          alt=""
          style="width:100%;height:100%;display:block"
          v-if="backImgBase || defaultImg"
        />
        <div class="verify-bg-img" v-else></div>
        <div
          class="verify-sub-block"
          v-show="type === '2' && blockBackImgBase"
          :style="{
            width: subBlockWidth + 'px',
            height: imgSize.height,
            top: '0px',
            left: subBlockLeft + 'px'
          }"
        >
          <img
            :src="'data:image/png;base64,' + blockBackImgBase"
            alt=""
            style="width:100%;height:100%;display:block"
          />
        </div>
        <div class="verify-refresh" @click="refresh" v-show="showRefresh && isHover">
          <span class="iconfont icon-jiazai"></span>
        </div>
        <transition name="tips">
          <div
            class="verify-tips"
            v-if="tipWords"
            :class="passFalg ? 'suc-bg' : 'err-bg'"
          >{{ tipWords }}</div>
        </transition>
      </div>
    </div>
    <!-- 滑动条区域 -->
    <div
      class="verify-bar-area"
      :style="{ width: imgSize.width, height: '40px', 'line-height': '40px' }"
      ref="barArea"
    >
      <span class="verify-msg" v-text="text"></span>
      <div
        class="verify-left-bar"
        :style="{ width: leftBarWidth, height: '40px', 'border-color': leftBarBorderColor, transition: transitionWidth }"
      >
        <span class="verify-msg" v-text="finishText"></span>
        <div
          class="verify-move-block"
          @mousedown="start"
          @touchstart.prevent="start"
          :style="{ width: '40px', height: '40px', 'background-color': moveBlockBackgroundColor, left: moveBlockLeft, transition: transitionLeft }"
        >
          <span :class="['verify-icon iconfont', iconClass]" :style="{ color: iconColor }"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { aesEncrypt } from "@utils/aes.js";
import { getAjcaptcha, ajcaptchaCheck } from "@api/public";

export default {
  name: "VerifySlider",
  props: {
    captchaType: {
      type: String,
      default: "blockPuzzle"
    },
    type: {
      type: String,
      default: "2"
    },
    mode: {
      type: String,
      default: "pop"
    },
    vSpace: {
      type: Number,
      default: 5
    },
    explain: {
      type: String,
      default: "向右滑动完成验证"
    },
    imgSize: {
      type: Object,
      default() {
        return { width: "310px", height: "155px" };
      }
    },
    blockSize: {
      type: Object,
      default() {
        return { width: "40px", height: "40px" };
      }
    },
    barSize: {
      type: Object,
      default() {
        return { width: "100%", height: "40px" };
      }
    },
    defaultImg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      secretKey: "",
      passFalg: false,
      backImgBase: "",
      blockBackImgBase: "",
      backToken: "",
      startMoveTime: "",
      endMovetime: "",
      tipWords: "",
      text: "",
      finishText: "",
      moveBlockLeft: "0px",
      leftBarWidth: "40px",
      moveBlockBackgroundColor: "#fff",
      leftBarBorderColor: "#ddd",
      iconColor: "#000",
      iconClass: "icon-arrow",
      status: false,
      isEnd: false,
      showRefresh: true,
      transitionLeft: "",
      transitionWidth: "",
      barAreaLeft: 0,
      barAreaOffsetWidth: 0,
      subBlockLeft: 0,
      subBlockWidth: 40,
      clientUid: ""
    };
  },
  computed: {
    maxWidth() {
      return this.barAreaOffsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2;
    }
  },
  mounted() {
    this.init();
    this._moveHandler = this.move.bind(this);
    this._endHandler = this.end.bind(this);
    document.addEventListener("mousemove", this._moveHandler);
    document.addEventListener("mouseup", this._endHandler);
    document.addEventListener("touchmove", this._moveHandler, { passive: false });
    document.addEventListener("touchend", this._endHandler);
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this._moveHandler);
    document.removeEventListener("mouseup", this._endHandler);
    document.removeEventListener("touchmove", this._moveHandler);
    document.removeEventListener("touchend", this._endHandler);
  },
  methods: {
    init() {
      this.text = this.explain;
      this.clientUid = this.uuid();
      this.$nextTick(() => {
        this.getBarAreaInfo();
        this.getPictrue();
        this.$emit("ready", this);
      });
    },
    getBarAreaInfo() {
      const barArea = this.$refs.barArea;
      if (barArea) {
        const rect = barArea.getBoundingClientRect();
        this.barAreaLeft = Math.ceil(rect.left);
        this.barAreaOffsetWidth = Math.ceil(rect.width);
        this.subBlockWidth = Math.floor(parseInt(this.imgSize.width) * 47 / 310);
      }
    },
    start(e) {
      if (this.isEnd) return;
      this.getBarAreaInfo();
      this.startMoveTime = new Date().getTime();
      this.text = "";
      this.moveBlockBackgroundColor = "#337ab7";
      this.leftBarBorderColor = "#337AB7";
      this.iconColor = "#fff";
      e.stopPropagation();
      e.preventDefault();
      this.status = true;
    },
    move(e) {
      if (!this.status || this.isEnd) return;
      let x;
      if (e.touches && e.touches.length > 0) {
        x = Math.ceil(e.touches[0].pageX);
      } else {
        x = Math.ceil(e.clientX);
      }
      e.preventDefault();
      let move_block_left = x - this.barAreaLeft;
      const halfBlock = parseInt(parseInt(this.blockSize.width) / 2);
      if (move_block_left >= this.barAreaOffsetWidth - halfBlock - 2) {
        move_block_left = this.barAreaOffsetWidth - halfBlock - 2;
      }
      if (move_block_left <= 0) {
        move_block_left = halfBlock;
      }
      const offset = move_block_left - halfBlock;
      this.moveBlockLeft = offset + "px";
      this.leftBarWidth = offset + "px";
      if (this.type === "2") {
        this.subBlockLeft = (offset * parseInt(this.imgSize.width)) / this.barAreaOffsetWidth;
      }
    },
    end() {
      this.endMovetime = new Date().getTime();
      if (!this.status || this.isEnd) return;
      this.status = false;
      if (this.type === "2") {
        let moveLeftDistance = parseInt((this.moveBlockLeft || "0").replace("px", ""));
        moveLeftDistance = (moveLeftDistance * 310) / parseInt(this.imgSize.width);
        const pointJson = this.secretKey
          ? aesEncrypt(JSON.stringify({ x: moveLeftDistance, y: 5.0 }), this.secretKey)
          : JSON.stringify({ x: moveLeftDistance, y: 5.0 });
        const captchaVerification = this.secretKey
          ? aesEncrypt(this.backToken + "---" + JSON.stringify({ x: moveLeftDistance, y: 5.0 }), this.secretKey)
          : this.backToken + "---" + JSON.stringify({ x: moveLeftDistance, y: 5.0 });
        const data = {
          captchaType: this.captchaType,
          pointJson: pointJson,
          token: this.backToken
        };
        ajcaptchaCheck(data)
          .then((r) => {
            const result = r.data;
            if (result.repCode == "0000") {
              const spanTime = (this.endMovetime - this.startMoveTime) / 1000;
              this.moveBlockBackgroundColor = "#5cb85c";
              this.leftBarBorderColor = "#5cb85c";
              this.iconColor = "#fff";
              this.iconClass = "icon-check";
              this.isEnd = true;
              this.passFalg = true;
              this.finishText = "";
              this.tipWords = `${spanTime.toFixed(2)}s验证成功`;
              this.leftBarWidth = this.barAreaOffsetWidth - 8 + "px";
              setTimeout(() => {
                this.tipWords = "";
                this.$emit("success", { captchaVerification });
              }, 800);
            } else {
              this.moveBlockBackgroundColor = "#d9534f";
              this.leftBarBorderColor = "#d9534f";
              this.iconColor = "#fff";
              this.iconClass = "icon-close";
              this.passFalg = false;
              this.tipWords = "验证失败";
              setTimeout(() => {
                this.refresh();
              }, 1000);
            }
          })
          .catch(() => {
            this.moveBlockBackgroundColor = "#d9534f";
            this.leftBarBorderColor = "#d9534f";
            this.iconColor = "#fff";
            this.iconClass = "icon-close";
            this.passFalg = false;
            this.tipWords = "验证失败";
            setTimeout(() => {
              this.refresh();
            }, 1000);
          });
      }
    },
    refresh() {
      this.showRefresh = true;
      this.finishText = "";
      this.transitionLeft = "left .3s";
      this.moveBlockLeft = "0px";
      this.leftBarWidth = "40px";
      this.transitionWidth = "width .3s";
      this.leftBarBorderColor = "#ddd";
      this.moveBlockBackgroundColor = "#fff";
      this.iconColor = "#000";
      this.iconClass = "icon-right";
      this.isEnd = false;
      this.passFalg = false;
      this.tipWords = "";
      this.$nextTick(() => {
        this.getBarAreaInfo();
        this.getPictrue();
        setTimeout(() => {
          this.transitionWidth = "";
          this.transitionLeft = "";
          this.text = this.explain;
        }, 300);
      });
    },
    getPictrue() {
      const data = {
        captchaType: this.captchaType,
        clientUid: this.clientUid,
        ts: Date.now()
      };
      getAjcaptcha(data)
        .then((r) => {
          const res = r.data;
          if (res.repCode == "0000") {
            this.backImgBase = res.repData.originalImageBase64;
            this.blockBackImgBase = res.repData.jigsawImageBase64;
            this.backToken = res.repData.token;
            this.secretKey = res.repData.secretKey || "";
          } else {
            this.tipWords = res.repMsg || "验证码获取失败";
            setTimeout(() => {
              this.tipWords = "";
            }, 2000);
          }
        })
        .catch(() => {
          this.backImgBase = "";
          this.blockBackImgBase = "";
        });
    },
    uuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";
      return s.join("");
    }
  }
};
</script>
<style scoped>
.verify-slider-wrapper {
  position: relative;
  width: 100%;
}
.verify-img-out {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.verify-img-panel {
  position: relative;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f0f0;
}
.verify-bg-img {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #f5576c 75%, #4facfe 100%);
  background-size: 400% 400%;
  animation: bgMove 8s ease infinite;
}
@keyframes bgMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
.verify-sub-block {
  position: absolute;
  z-index: 2;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  overflow: hidden;
}
.verify-refresh {
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
  height: 34px;
  cursor: pointer;
  text-align: center;
  line-height: 34px;
  font-size: 18px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 3;
  border-radius: 0 4px 0 0;
}
.verify-tips {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  z-index: 3;
}
.verify-tips.suc-bg {
  background-color: rgba(40, 167, 69, 0.7);
}
.verify-tips.err-bg {
  background-color: rgba(220, 53, 69, 0.7);
}
.tips-enter-active,
.tips-leave-active {
  transition: bottom 0.5s;
}
.tips-enter,
.tips-leave-to {
  bottom: -30px;
}
.verify-bar-area {
  position: relative;
  background: #f7f7f7;
  text-align: center;
  box-sizing: content-box;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 8px;
}
.verify-bar-area .verify-msg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #999;
  font-size: 14px;
  z-index: 0;
}
.verify-left-bar {
  position: absolute;
  top: -1px;
  left: -1px;
  box-sizing: content-box;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: rgba(51, 122, 183, 0.1);
}
.verify-left-bar .verify-msg {
  color: #ffffff;
}
.verify-move-block {
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  cursor: grab;
  box-sizing: content-box;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
}
.verify-move-block:hover {
  background-color: #337ab7;
}
.verify-move-block:hover .verify-icon {
  color: #ffffff;
}
.verify-move-block:active {
  cursor: grabbing;
}
.verify-icon {
  font-size: 18px;
  color: #666;
}
</style>
